import React from "react";

const DownArrow = ({ color, height, width }) => (
  <svg width={width} height={height} viewBox="0 0 18 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 10L0 1.59159L1.5 0L9 7.03704L16.5 0L18 1.59159L9 10Z" fill={color} />
  </svg>
);

DownArrow.defaultProps = {
  width: 28,
  height: 28,
  color: "#666"
};

export default DownArrow;
